import React from 'react';
import { View, Image, Text, StyleSheet } from 'react-native';
import FreeText from './FreeText';
import ChooseOne from './ChooseOne';
import Email from './Email';
import NPS from './NPS';
import MultipleChoiceQuestion from './MultipleChoice';
import { FONT_STYLE } from '../../dataSchema/const';
import InputText from './Text';
import ImageQuestion from './Image';
import Rating from './Rating';
import DateTimePicker from './DatePicker';
import InputPhoneNumber from './Phone';
import SliderRate from './Slider';
import Feel from './Feel';
import LikertV2 from './Likert';
import Likert from './Likert';

export interface CardQuestionProperties {
  label: string,
  imageUrl: string,
  multipleChoice: boolean,
  required: boolean,
  questionNumber: number,

}

export const CardQuestion = ({ data, answerHandle, defaultAnswer }) => {
  const value: CardQuestionProperties = data
  const handleSelect = (selectedOption) => {
    let answers: string[] = []
    answers.push(selectedOption);
    let answer = {
      questionId: data.id || '',
      type: data.type,
      values: answers,
      other: null,
      required: data.required,
      isCustome: data.customChoice,
    }
    if (answerHandle) {
      answerHandle(answer);
    }
  };

  const handleSelectNPS = (point, reason) => {
    if (point < 0 || point > 10) return;
    let answers = []
    answers.push(point);
    let answer = {
      questionId: data.id || '',
      type: data.type,
      values: answers,
      other: reason && reason.length ? reason : null,
      required: data.required
    }
    if (answerHandle) {
      answerHandle(answer);
    }
  };

  const handleSelectLikert = (point) => {
    if (point < 0 || point > 10) return;
    let answers = []
    answers.push(point);
    let answer = {
      questionId: data.id || '',
      type: data.type,
      values: answers,
      other: null,
      required: data.required
    }
    if (answerHandle) {
      answerHandle(answer);
    }
  };

  const handleSelectRating = (point) => {
    if (point < -1 || point > 10) return;
    let answers = []
    answers.push(point);
    let answer = {
      questionId: data.id || '',
      type: data.type,
      values: answers,
      other: null,
      required: data.required
    }
    if (answerHandle) {
      answerHandle(answer);
    }
  };

  const handleToggleSelect = (choices) => {
    let answer = {
      questionId: data.id || '',
      type: data.type,
      values: choices,
      other: null,
      required: data.required,
      multipleChoice: true,
      isCustome: data.customChoice,
    }
    if (answerHandle) {
      answerHandle(answer);
    }
  };

  let inputField: string = ''

  const handleTextInput = (text) => {
    if (inputField === text) return;
    inputField = text;
    let answers: string[] = []
    answers.push(text);
    let answer = {
      questionId: data.id || '',
      type: data.type,
      values: answers,
      other: null,
      required: data.required
    }
    if (answerHandle) {
      answerHandle(answer);
    }
  }

  // Component map pattern (Factory/Strategy)
  const questionTypeMap = {
    TEXT: () => <InputText handleText={handleTextInput} defaultAnswer={defaultAnswer} />,
    FREE_TEXT: () => <FreeText handleText={handleTextInput} defaultAnswer={defaultAnswer} />,
    CHOICE: () =>
      data.multipleChoice
        ? <MultipleChoiceQuestion question={data} selectHandler={handleToggleSelect} defaultAnswer={defaultAnswer} isCustom={data.customChoice} />
        : <ChooseOne options={data.choices} onSelect={handleSelect} defaultAnswer={defaultAnswer} isCustom={data.customChoice} />,
    EMOTION: () => <Feel onSelect={handleSelectNPS} defaultAnswer={defaultAnswer} isCustom={data.customChoice} />,
    IMAGE: () => <ImageQuestion options={data.choices} onSelect={handleSelect} defaultAnswer={defaultAnswer} />,
    EMAIL: () => <Email handleText={handleTextInput} defaultAnswer={defaultAnswer} />,
    NPS0_10: () => <NPS onSelect={handleSelectNPS} defaultAnswer={defaultAnswer} isCustom={data.hasFollowUpQuestion} followUpQuestion={data.followUpQuestion} startText={data.startText} endText={data.endText} />,
    NPS: () => <NPS onSelect={handleSelectNPS} defaultAnswer={defaultAnswer} isCustom={data.hasFollowUpQuestion} followUpQuestion={data.followUpQuestion} startText={data.startText} endText={data.endText} />,
    RATING: () => <Rating onSelect={handleSelectRating} defaultAnswer={defaultAnswer} />,
    DATE: () => <DateTimePicker onSelect={handleSelect} defaultAnswer={defaultAnswer} />,
    LIKERT: () => <Likert onSelect={handleSelectLikert} defaultAnswer={defaultAnswer} option={data.likertType} startText={data.startText} endText={data.endText} />,
    PHONE: () => <InputPhoneNumber handleText={handleTextInput} defaultAnswer={defaultAnswer} />,
  };

  const renderQuestionType = (data) => {
    if (!data) return <></>;
    const render = questionTypeMap[data.type];
    return render ? render() : <></>;
  }

  return (
    <View style={styles.container}>
      <View style={styles.questionCard}>
        <Text style={styles.questionNum}>
          {!data.depend ? `${data.questionNumber} .` : ""}
          <Text style={styles.questionLabel}>{value.label}
            <Text style={styles.require}>
              {` ${value.required ? '(*)' : ''}`}
            </Text>
          </Text>
          {
            value.imageUrl && value.imageUrl.length ?
              (<Image source={{ uri: value.imageUrl }} style={styles.image}></Image>)
              : null
          }
        </Text>
        {renderQuestionType(data)}
      </View>
    </View>
  );
};

const styles = StyleSheet.create(
  {
    container: {
      marginTop: 15
    },
    questionCard: {
      padding: 15,
      backgroundColor: '#FFFFFF',
      color: '#000000',

    },
    questionNum: {
      fontSize: 14,
      fontFamily: FONT_STYLE.BOLD,
    },
    questionLabel: {
      fontSize: 14,
      fontFamily: FONT_STYLE.MEDIUM,
    },
    require: {
      fontSize: 14,
      fontFamily: FONT_STYLE.MEDIUM,
      fontWeight: '600',
      color: '#F65D79'
    },
    image: {
      marginTop: 15,
      width: 343,
      height: 171,
      resizeMode: 'center',
    }
  }
)
